import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router';
import { appSurface } from './surface';

const DocsPage = lazy(() => import('./docs/DocsPage'));
const AdminPage = lazy(() => import('./admin/AdminPage'));
const CrmPage = lazy(() => import('./crm/CrmPage'));
const CompetePage = lazy(() => import('./compete/CompetePage'));
const SettingsPage = lazy(() => import('./settings/SettingsPage'));
const LearnPage = lazy(() => import('./learn/LearnPage'));
const GetHiredPage = lazy(() => import('./get-hired/GetHiredPage'));

export function App() {
  const surface = appSurface();

  // Get Hired mounts its own RouterProvider — do not wrap in parent <Routes>.
  if (surface === 'get-hired') {
    return (
      <Suspense fallback={<p style={{ margin: '2rem', fontFamily: 'system-ui' }}>Loading</p>}>
        <GetHiredPage />
      </Suspense>
    );
  }

  const Page =
    surface === 'admin' ? AdminPage
      : surface === 'crm' ? CrmPage
        : surface === 'compete' ? CompetePage
          : surface === 'settings' ? SettingsPage
            : surface === 'learn' ? LearnPage
              : DocsPage;

  return (
    <Suspense fallback={<p style={{ margin: '2rem', fontFamily: 'system-ui' }}>Loading</p>}>
      <Routes>
        <Route path="/*" element={<Page />} />
      </Routes>
    </Suspense>
  );
}
